import * as Sentry from '@sentry/react';

import { IGNORE_ERRORS, IGNORE_URLS } from '@nubank/www-latam-commons/utils/sentry';

function init({ dsn, environment }) {
  if (!dsn) { return; }

  Sentry.init({
    dsn,
    ignoreErrors: IGNORE_ERRORS,
    ignoreUrls: IGNORE_URLS,
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    environment,
  });
}

export const errorTracking = {
  init,
};
